<template>
    <div>
        <div class="grid grid-cols-12 gap-6 border-b-1 pb-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/co-najdete-v-prazskem-ulicniku"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/co_najdete_v_prazskem_ulicniku.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/co-najdete-v-prazskem-ulicniku"
                        class="underline"
                    >
                        Co najdete v Pražském uličníku
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Co je a co není možné najít v naší databázi, struktura
                    hesla, aktualizace informací v databázi a další praktické
                    tipy
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/co-najdete-v-prazskem-ulicniku"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/autori"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/autori.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/autori"
                        class="underline"
                    >
                        Autoři
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Jak knižní vydání, tak internetová aplikace, jsou dílem
                    mnoha lidí, a dá se říci i mnoha generací. Na aplikaci se
                    podílely dvě významné pražské instituce: Archiv hl. m. Prahy
                    a Institut plánování a rozvoje hl. m. Prahy.
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/autori"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <a
                    href="https://www.academiaknihy.cz/kniha/prazsky-ulicnik-encyklopedie-nazvu-prazskych-verejnych-prostranstvi-2-prepracovane-a-doplnene-vyd/"
                    target="_blank"
                    class="article-link"
                    ><img
                        src="../public/img/articles/kniha_prazsky_ulicnik.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                /></a>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <a
                        href="https://www.academiaknihy.cz/kniha/prazsky-ulicnik-encyklopedie-nazvu-prazskych-verejnych-prostranstvi-2-prepracovane-a-doplnene-vyd/"
                        target="_blank"
                        class="article-link"
                        >Kniha</a
                    >
                </p>
                <p class="font-medium">
                    Zájemce o knižní verzi vydanou nakladatelstvím Academia v
                    roce 2022 upozorňujeme, že je stále v prodeji.
                </p>
                <p class="mt-5 font-bold">
                    >
                    <a
                        href="https://www.academiaknihy.cz/kniha/prazsky-ulicnik-encyklopedie-nazvu-prazskych-verejnych-prostranstvi-2-prepracovane-a-doplnene-vyd/"
                        target="_blank"
                        class="article-link"
                        >Pražský uličník. Encyklopedie názvů pražských veřejných
                        prostranství, 2. přepracované a doplněné vydání</a
                    >
                </p>
            </div>
        </div>

        <div class="mt-10 mb-10 flex flex-col items-center justify-center">
            <nuxt-link
                to="/kontakt"
                class="font-bold"
            >
                <h2 class="mb-10 text-[#002793] underline">Kontakt</h2>
            </nuxt-link>
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
